import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const CalendarRoutes = [
  {
    path: '/calendars',
    name: 'ListCalendars',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'calendar:list'
    }
  },
  {
    path: '/calendar/',
    name: 'CreateCalendar',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'calendar:create'
    }
  },
  {
    path: '/calendar/:id',
    name: 'UpdateCalendar',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'calendar:update'
    }
  },
  {
    path: '/calendar/view/:id',
    name: 'GetCalendar',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'calendar:get'
    }
  }
]
